/**
 * Gate for framer-motion entrance animations (fade/slide-in on load or scroll).
 *
 * Entrance animations start elements at `opacity: 0`. If we let them run during
 * server-side prerendering, the static HTML ships with content hidden by inline
 * styles — invisible to users until JS loads and invisible-ish to non-JS
 * crawlers. So:
 *
 *  - During SSR (build-time prerender): disabled — HTML shows final state.
 *  - During hydration of prerendered HTML: disabled, so the client's first
 *    render matches the server output (no hydration mismatch).
 *  - After the first client-side navigation: enabled — SPA navigations get
 *    the normal entrance animations.
 *
 * Pages spread `{...entrance(animProps)}` onto motion components instead of
 * spreading the animation props directly.
 */

let enabled = true;

if (import.meta.env.SSR) {
  enabled = false;
} else if (typeof document !== 'undefined') {
  const root = document.getElementById('root');
  // Prerendered pages boot with server HTML already in #root.
  if (root && root.hasChildNodes()) enabled = false;
}

export const enableEntranceAnimations = (): void => {
  enabled = true;
};

export function entrance<T extends object>(props: T): T | Record<string, never> {
  return enabled ? props : {};
}
